<div *ngIf="!validating">
    <app-not-found *ngIf="!isValidToken"></app-not-found>
    <div *ngIf="isValidToken" class="container py-4 clearfix">
        <div *ngIf="optedIn">
            <h4 style="text-align: center;">{{ 'MEMBER-OPTED-IN' | translate}}</h4>
        </div>
        <br /><br />
        <div class="col-12">
            <div *ngIf="optedIn" class="row">
                <div class="col-12" style="text-align: center;">
                    <span>{{'MEMBER-OPTED-IN-INFO' | translate}}</span>
                </div>
            </div>
            <div *ngIf="!optedIn" class="row">
                <div class="col-12" style="text-align: center;">
                    <span>{{'MEMBER-SAVE-ERROR' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>